export enum PayoutFrequencyType {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    TWICEAMONTH = 'TWICEAMONTH',
    MONTHLY = 'MONTHLY'
}

export enum GENERAL_FORM_FIELDS {
	// BUREAU_PRODUCTION = 'IsBureauProductionActive',
	LOCK_MERCHANT = 'Locked',
	// PAYOUTS_ENABLE = 'payoutEnabled',
	MIT_ENABLE = 'isMitEnabled',
	MIT_EVALUATE_ASYNC = 'isMITEvaluateAsync',
	CIT_EVALUATE_ASYNC = 'isCITEvaluateAsync',
	VIRTUAL_TERMINAL_ENABLED = 'VirtualTerminalEnabled',
	MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED = 'mitGetSiteByDynamicDescriptorEnabled',
	MIT_CONSUMER_NOTIFICATIONS_ENABLED = 'mitConsumerNotificationsEnabled',
	CONSUMER_NOTIFICATION_CHANNEL = 'consumerOrderNotificationChannel',
	MIT_CONSUMER_CURES_ENABLED = 'mitConsumerCuresEnabled',
	UI_WIDGET_OPTIONAL = 'uiWidgetOptional',
	CIT_CONSUMER_NOTIFICATIONS_ENABLED = 'citConsumerNotificationsEnabled',
	ALLOW_BIN_CHECK = 'allowBinCheckOnTokenization',
	REFUND_ENABLED_CIT = 'citClickToRefundEnabled',
	REFUND_ENABLED_MIT = 'mitClickToRefundEnabled',
	IS_SENSE_JS_OPTIONAL = 'isSenseJsOptional',
	USE_DEFAULT_SITE = 'useDefaultSiteForUnknownMerchantUrlsEnabled',
	BILLING_INFORMATION_OPTIONAL = 'billingInformationOptional',
	ENABLE_ACCOUNT_UPDATE = 'accountUpdaterEnabled',
	ENABLE_GLOBAL_NETWORK_TOKENIZATION = 'enableGlobalNetworkTokenization',
	ENABLE_CRAWLING = 'enableGCrawling',
	ENABLE_FRAME_EVENTS_COLLECT = 'enableFrameEventsCollect',
	ENABLE_ENFORCE_MFA = 'enableEnforceMFA',
	ENABLE_GLOBAL_3DS = 'global3DSEnabled',
	INFORMATIONAL_3DS = 'informationalOnly3DS',
	CAPTURE_REQUIRED = 'captureRequired',
	ENABLE_MERCHANT_SCHEME_TRANSACTION_ID = 'schemeTransactionIdEnabled',
	REDACT_IP_ENABLED = 'redactIpEnabled',
	PAYER_ENABLED = 'payerEnabled',
	ENABLE_IMMEDIATE_RETRY = 'mitImmediateRetryEnabled',
	IS_AVS_REQUIRED = 'isAvsRequired',
	IS_CVV_REQUIRED = 'isCvvRequired',
	SUPPORTED_COUNTRIES = 'supportedCountries',
}

// Add new enum for funding configuration fields
export enum FUNDING_CONFIG_FORM_FIELDS {
	PAYOUTS_ENABLE = 'payoutEnabled',
	PAYOUT_FREQUENCY = 'payoutFrequency',
	PAYOUT_BATCHES_AUTO_POSTING = 'payoutBatchesAutoPostingEnabled',
	PAYOUT_BATCHES_SETTLED_OFFLINE = 'payoutBatchesSettledOffline',
}

export enum GENERAL_FORM_FIELDS_NAMES {
	// BUREAU_PRODUCTION = 'NEW_APPLICATION.LABEL.BUREAU_PRODUCTION',
	LOCK_MERCHANT = 'NEW_APPLICATION.LABEL.LOCK_MERCHANT',
	LOCK_MERCHANT_DESCRIPTION = 'NEW_APPLICATION.LABEL.LOCK_MERCHANT_DESCRIPTION',
	// PAYOUTS_ENABLE = 'NEW_APPLICATION.LABEL.PAYOUTS_ENABLE',
	// PAYOUTS_ENABLE_DESCRIPTION = 'NEW_APPLICATION.LABEL.PAYOUTS_ENABLE_DESCRIPTION',
	MIT_ENABLE = 'NEW_APPLICATION.LABEL.MIT_ENABLE',
	MIT_ENABLE_DESCRIPTION = 'NEW_APPLICATION.LABEL.MIT_ENABLE_DESCRIPTION',
	MIT_EVALUATE_ASYNC = 'NEW_APPLICATION.LABEL.MIT_EVALUATE_ASYNC',
	CIT_EVALUATE_ASYNC = 'NEW_APPLICATION.LABEL.CIT_EVALUATE_ASYNC',
	MIT_EVALUATE_ASYNC_DESCRIPTION = 'NEW_APPLICATION.LABEL.MIT_EVALUATE_ASYNC_DESCRIPTION',
	CIT_EVALUATE_ASYNC_DESCRIPTION = 'NEW_APPLICATION.LABEL.CIT_EVALUATE_ASYNC_DESCRIPTION',
	VIRTUAL_TERMINAL_ENABLED = 'NEW_APPLICATION.LABEL.VIRTUAL_TERMINAL_ENABLED',
	VIRTUAL_TERMINAL_ENABLED_DESCRIPTION = 'NEW_APPLICATION.LABEL.VIRTUAL_TERMINAL_ENABLED_DESCRIPTION',
	MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED = 'NEW_APPLICATION.LABEL.MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED',
	MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED_DESCRIPTION = 'NEW_APPLICATION.LABEL.MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED_DESCRIPTION',
	MIT_CONSUMER_NOTIFICATIONS_ENABLED = 'NEW_APPLICATION.LABEL.MIT_CONSUMER_NOTIFICATIONS_ENABLED',
	CONSUMER_NOTIFICATION_CHANNEL = 'NEW_APPLICATION.LABEL.CONSUMER_NOTIFICATION_CHANNEL',
	CONSUMER_NOTIFICATION_CHANNEL_DESCRIPTION = 'NEW_APPLICATION.LABEL.CONSUMER_NOTIFICATION_CHANNEL_DESCRIPTION',
	MIT_CONSUMER_NOTIFICATIONS_ENABLED_DESCRIPTION = 'NEW_APPLICATION.LABEL.MIT_CONSUMER_NOTIFICATIONS_ENABLED_DESCRIPTION',
	MIT_CONSUMER_CURES_ENABLED = 'NEW_APPLICATION.LABEL.MIT_CONSUMER_CURES_ENABLED',
	MIT_CONSUMER_CURES_ENABLED_DESCRIPTION = 'NEW_APPLICATION.LABEL.MIT_CONSUMER_CURES_ENABLED_DESCRIPTION',
	UI_WIDGET_OPTIONAL = 'NEW_APPLICATION.LABEL.UI_WIDGET_OPTIONAL',
	UI_WIDGET_OPTIONAL_DESCRIPTION = 'NEW_APPLICATION.LABEL.UI_WIDGET_OPTIONAL_DESCRIPTION',
	CIT_CONSUMER_NOTIFICATIONS_ENABLED = 'NEW_APPLICATION.LABEL.CIT_CONSUMER_NOTIFICATIONS_ENABLED',
	CIT_CONSUMER_NOTIFICATIONS_ENABLED_DESCRIPTION = 'NEW_APPLICATION.LABEL.CIT_CONSUMER_NOTIFICATIONS_ENABLED_DESCRIPTION',
	ALLOW_BIN_CHECK = 'NEW_APPLICATION.LABEL.ALLOW_BIN_CHECK',
	ALLOW_BIN_CHECK_DESCRIPTION = 'NEW_APPLICATION.LABEL.ALLOW_BIN_CHECK_DESCRIPTION',
	REFUND_ENABLED_CIT = 'NEW_APPLICATION.LABEL.REFUND_ENABLED_CIT',
	REFUND_ENABLED_CIT_DESCRIPTION = 'NEW_APPLICATION.LABEL.REFUND_ENABLED_CIT_DESCRIPTION',
	REFUND_ENABLED_MIT = 'NEW_APPLICATION.LABEL.REFUND_ENABLED_MIT',
	REFUND_ENABLED_MIT_DESCRIPTION = 'NEW_APPLICATION.LABEL.REFUND_ENABLED_MIT_DESCRIPTION',
	IS_SENSE_JS_OPTIONAL = 'NEW_APPLICATION.LABEL.IS_SENSE_JS_OPTIONAL',
	IS_SENSE_JS_OPTIONAL_DESCRIPTION = 'NEW_APPLICATION.LABEL.IS_SENSE_JS_OPTIONAL_DESCRIPTION',
	USE_DEFAULT_SITE = 'NEW_APPLICATION.LABEL.USE_DEFAULT_SITE',
	USE_DEFAULT_SITE_DESCRIPTION = 'NEW_APPLICATION.LABEL.USE_DEFAULT_SITE_DESCRIPTION',
	ENABLE_ACCOUNT_UPDATE = 'NEW_APPLICATION.LABEL.ENABLE_ACCOUNT_UPDATE',
	ENABLE_ACCOUNT_UPDATE_DESCRIPTION = 'NEW_APPLICATION.LABEL.ENABLE_ACCOUNT_UPDATE_DESCRIPTION',
	ENABLE_GLOBAL_NETWORK_TOKENIZATION = 'NEW_APPLICATION.LABEL.ENABLE_GLOBAL_NETWORK_TOKENIZATION',
	ENABLE_GLOBAL_NETWORK_TOKENIZATION_DESCRIPTION = 'NEW_APPLICATION.LABEL.ENABLE_GLOBAL_NETWORK_TOKENIZATION_DESCRIPTION',
	ENABLE_CRAWLING = 'NEW_APPLICATION.LABEL.ENABLE_CRAWLING',
	ENABLE_FRAME_EVENTS_COLLECT = 'NEW_APPLICATION.LABEL.ENABLE_FRAME_EVENTS_COLLECT',
	ENABLE_CRAWLING_DESCRIPTION = 'NEW_APPLICATION.LABEL.ENABLE_CRAWLING_DESCRIPTION',
	ENABLE_FRAME_EVENTS_COLLECT_DESCRIPTION = 'NEW_APPLICATION.LABEL.ENABLE_FRAME_EVENTS_COLLECT_DESCRIPTION',
	ENABLE_ENFORCE_MFA = 'NEW_APPLICATION.LABEL.ENABLE_ENFORCE_MFA',
	ENABLE_ENFORCE_MFA_DESCRIPTION = 'NEW_APPLICATION.LABEL.ENABLE_ENFORCE_MFA_DESCRIPTION',
	BILLING_INFORMATION_OPTIONAL = 'NEW_APPLICATION.LABEL.BILLING_INFORMATION_OPTIONAL',
	BILLING_INFORMATION_OPTIONAL_DESCRIPTION = 'NEW_APPLICATION.LABEL.BILLING_INFORMATION_OPTIONAL_DESCRIPTION',
	ENABLE_GLOBAL_3DS = 'NEW_APPLICATION.LABEL.ENABLE_GLOBAL_3DS',
	ENABLE_GLOBAL_3DS_DESCRIPTION = 'NEW_APPLICATION.LABEL.ENABLE_GLOBAL_3DS_DESCRIPTION',
	INFORMATIONAL_3DS = 'NEW_APPLICATION.LABEL.INFORMATIONAL_3DS',
	INFORMATIONAL_3DS_DESCRIPTION = 'NEW_APPLICATION.LABEL.INFORMATIONAL_3DS_DESCRIPTION',
	CAPTURE_REQUIRED = 'NEW_APPLICATION.LABEL.CAPTURE_REQUIRED',
	CAPTURE_REQUIRED_DESCRIPTION = 'NEW_APPLICATION.LABEL.CAPTURE_REQUIRED_DESCRIPTION',
	ENABLE_MERCHANT_SCHEME_TRANSACTION_ID = 'NEW_APPLICATION.LABEL.ENABLE_MERCHANT_SCHEME_TRANSACTION_ID',
	REDACT_IP_ENABLED = 'NEW_APPLICATION.LABEL.REDACT_IP_ENABLED',
	PAYER_ENABLED = 'NEW_APPLICATION.LABEL.PAYER_ENABLED',
	ENABLE_MERCHANT_SCHEME_TRANSACTION_ID_DESCRIPTION = 'NEW_APPLICATION.LABEL.ENABLE_MERCHANT_SCHEME_TRANSACTION_ID_DESCRIPTION',
	REDACT_IP_ENABLED_DESCRIPTION = 'NEW_APPLICATION.LABEL.REDACT_IP_ENABLED_DESCRIPTION',
	PAYER_ENABLED_DESCRIPTION = 'NEW_APPLICATION.LABEL.PAYER_ENABLED_DESCRIPTION',
	ENABLE_IMMEDIATE_RETRY = 'NEW_APPLICATION.LABEL.ENABLE_IMMEDIATE_RETRY',
	ENABLE_IMMEDIATE_RETRY_DESCRIPTION = 'NEW_APPLICATION.LABEL.ENABLE_IMMEDIATE_RETRY_DESCRIPTION',
	IS_AVS_REQUIRED = 'NEW_APPLICATION.LABEL.IS_AVS_REQUIRED',
	IS_AVS_REQUIRED_DESCRIPTION = 'NEW_APPLICATION.LABEL.IS_AVS_REQUIRED_DESCRIPTION',
	IS_CVV_REQUIRED = 'NEW_APPLICATION.LABEL.IS_CVV_REQUIRED',
	IS_CVV_REQUIRED_DESCRIPTION = 'NEW_APPLICATION.LABEL.IS_CVV_REQUIRED_DESCRIPTION',
	SUPPORTED_COUNTRIES = 'NEW_APPLICATION.LABEL.SUPPORTED_COUNTRIES',
	SUPPORTED_COUNTRIES_DESCRIPTION = 'NEW_APPLICATION.LABEL.SUPPORTED_COUNTRIES_DESCRIPTION',
}

// Add new enum for funding configuration field names
export enum FUNDING_CONFIG_FORM_FIELDS_NAMES {
	PAYOUTS_ENABLE = 'NEW_APPLICATION.LABEL.PAYOUTS_ENABLE',
	PAYOUTS_ENABLE_DESCRIPTION = 'NEW_APPLICATION.LABEL.PAYOUTS_ENABLE_DESCRIPTION',
	PAYOUT_FREQUENCY = 'NEW_APPLICATION.LABEL.PAYOUT_FREQUENCY',
	PAYOUT_FREQUENCY_DESCRIPTION = 'NEW_APPLICATION.LABEL.PAYOUT_FREQUENCY_DESCRIPTION',
	PAYOUT_BATCHES_AUTO_POSTING = 'NEW_APPLICATION.LABEL.PAYOUT_BATCHES_AUTO_POSTING',
	PAYOUT_BATCHES_AUTO_POSTING_DESCRIPTION = 'NEW_APPLICATION.LABEL.PAYOUT_BATCHES_AUTO_POSTING_DESCRIPTION',
	PAYOUT_BATCHES_SETTLED_OFFLINE = 'NEW_APPLICATION.LABEL.PAYOUT_BATCHES_SETTLED_OFFLINE',
	PAYOUT_BATCHES_SETTLED_OFFLINE_DESCRIPTION = 'NEW_APPLICATION.LABEL.PAYOUT_BATCHES_SETTLED_OFFLINE_DESCRIPTION',
}

export type GeneralFieldsTypes = {
	// [GENERAL_FORM_FIELDS.BUREAU_PRODUCTION]: boolean;
	[GENERAL_FORM_FIELDS.LOCK_MERCHANT]: boolean;
	// [GENERAL_FORM_FIELDS.PAYOUTS_ENABLE]: boolean;
	[GENERAL_FORM_FIELDS.MIT_ENABLE]?: boolean;
	[GENERAL_FORM_FIELDS.MIT_EVALUATE_ASYNC]?: boolean;
	[GENERAL_FORM_FIELDS.CIT_EVALUATE_ASYNC]?: boolean;
	[GENERAL_FORM_FIELDS.VIRTUAL_TERMINAL_ENABLED]?: boolean;
	[GENERAL_FORM_FIELDS.MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED]?: boolean;
	[GENERAL_FORM_FIELDS.MIT_CONSUMER_NOTIFICATIONS_ENABLED]?: boolean;
	[GENERAL_FORM_FIELDS.CONSUMER_NOTIFICATION_CHANNEL]?: string | null;
	[GENERAL_FORM_FIELDS.MIT_CONSUMER_CURES_ENABLED]?: boolean;
	[GENERAL_FORM_FIELDS.UI_WIDGET_OPTIONAL]?: boolean;
	[GENERAL_FORM_FIELDS.CIT_CONSUMER_NOTIFICATIONS_ENABLED]?: boolean;
	[GENERAL_FORM_FIELDS.ALLOW_BIN_CHECK]?: boolean;
	[GENERAL_FORM_FIELDS.REFUND_ENABLED_CIT]?: boolean;
	[GENERAL_FORM_FIELDS.REFUND_ENABLED_MIT]?: boolean;
	[GENERAL_FORM_FIELDS.IS_SENSE_JS_OPTIONAL]?: boolean;
	[GENERAL_FORM_FIELDS.USE_DEFAULT_SITE]?: boolean;
	[GENERAL_FORM_FIELDS.ENABLE_ACCOUNT_UPDATE]?: boolean;
	[GENERAL_FORM_FIELDS.ENABLE_GLOBAL_NETWORK_TOKENIZATION]?: boolean;
	[GENERAL_FORM_FIELDS.ENABLE_CRAWLING]?: boolean;
	[GENERAL_FORM_FIELDS.ENABLE_FRAME_EVENTS_COLLECT]?: boolean;
	[GENERAL_FORM_FIELDS.ENABLE_ENFORCE_MFA]?: boolean;
	[GENERAL_FORM_FIELDS.BILLING_INFORMATION_OPTIONAL]?: boolean;
	[GENERAL_FORM_FIELDS.ENABLE_GLOBAL_3DS]?: boolean;
	[GENERAL_FORM_FIELDS.INFORMATIONAL_3DS]?: boolean;
	[GENERAL_FORM_FIELDS.CAPTURE_REQUIRED]?: boolean;
	[GENERAL_FORM_FIELDS.ENABLE_MERCHANT_SCHEME_TRANSACTION_ID]?: boolean;
	[GENERAL_FORM_FIELDS.REDACT_IP_ENABLED]?: boolean;
	[GENERAL_FORM_FIELDS.PAYER_ENABLED]?: boolean;
	[GENERAL_FORM_FIELDS.ENABLE_IMMEDIATE_RETRY]?: boolean;
	[GENERAL_FORM_FIELDS.IS_AVS_REQUIRED]?: boolean;
	[GENERAL_FORM_FIELDS.IS_CVV_REQUIRED]?: boolean;
	[GENERAL_FORM_FIELDS.SUPPORTED_COUNTRIES]?: string[];

	// Add funding configuration fields to GeneralFieldsTypes
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE]?: boolean;
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY]?: string | null;
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING]?: boolean | null;
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE]?: boolean | null;
}

// Add new type for funding configuration fields
export type FundingConfigFieldsTypes = {
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE]: boolean;
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY]: string | null;
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING]: boolean | null;
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE]: boolean | null;
}

export type GeneralFieldsReturnTypes = {
	// isBureauProductionActive: boolean,
	locked: boolean;
	// payoutsEnabled: boolean;
	isMitEnabled?: boolean;
	isMITEvaluateAsync?: boolean;
	isCITEvaluateAsync?: boolean;
	virtualTerminalEnabled?: boolean;
	mitGetSiteByDynamicDescriptorEnabled?: boolean;
	mitConsumerNotificationsEnabled?: boolean;
	consumerOrderNotificationChannel?: string | null;
	mitConsumerCuresEnabled?: boolean;
	uiWidgetOptional?: boolean | null;
	citConsumerNotificationsEnabled?: boolean;
	allowBinCheckOnTokenization?: boolean;
	citClickToRefundEnabled?: boolean;
	mitClickToRefundEnabled?: boolean;
	isSenseJsOptional?: boolean;
	useDefaultSiteForUnknownMerchantUrlsEnabled?: boolean;
	accountUpdaterEnabled?: boolean;
	enableGlobalNetworkTokenization?: boolean;
	isCrawlingEnabled?: boolean;
	isIframeMessagesCollectEnabled?: boolean;
	isEnforceMFAEnabled?: boolean;
	billingInformationOptional?: boolean;
	global3DSEnabled?: boolean;
	informationalOnly3DS?: boolean;
	captureRequired?: boolean;
	schemeTransactionIdEnabled?: boolean;
	redactIpEnabled?: boolean;
	payerEnabled?: boolean;
	mitImmediateRetryEnabled?: boolean;
	isAvsRequired?: boolean;
	isCvvRequired?: boolean;
	supportedCountries?: string[];

	// Add fundingConfiguration to GeneralFieldsReturnTypes
	fundingConfiguration?: {
		payoutsEnabled: boolean;
		payoutFrequency: string | null;
		payoutBatchesAutoPostingEnabled: boolean | null;
		payoutBatchesSettledOffline: boolean | null;
	};
}

// Add new return type for funding configuration
export type FundingConfigFieldsReturnTypes = {
	payoutsEnabled: boolean;
	payoutFrequency: string | null;
	payoutBatchesAutoPostingEnabled: boolean | null;
	payoutBatchesSettledOffline: boolean | null;
}

export const initialPartnerGeneralValues: GeneralFieldsTypes = {
	// [GENERAL_FORM_FIELDS.BUREAU_PRODUCTION]: false,
	[GENERAL_FORM_FIELDS.LOCK_MERCHANT]: false,
	// [GENERAL_FORM_FIELDS.PAYOUTS_ENABLE]: false,
};

// Add initial values for funding configuration
export const initialPartnerFundingConfigValues: FundingConfigFieldsTypes = {
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE]: false,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY]: null,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING]: null,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE]: null,
};

export const initialAdminGeneralValues: GeneralFieldsTypes = {
	// [GENERAL_FORM_FIELDS.BUREAU_PRODUCTION]: false,
	[GENERAL_FORM_FIELDS.LOCK_MERCHANT]: false,
	// [GENERAL_FORM_FIELDS.PAYOUTS_ENABLE]: false,
	[GENERAL_FORM_FIELDS.MIT_ENABLE]: false,
	[GENERAL_FORM_FIELDS.MIT_EVALUATE_ASYNC]: false,
	[GENERAL_FORM_FIELDS.CIT_EVALUATE_ASYNC]: false,
	[GENERAL_FORM_FIELDS.VIRTUAL_TERMINAL_ENABLED]: false,
	[GENERAL_FORM_FIELDS.MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED]: false,
	[GENERAL_FORM_FIELDS.MIT_CONSUMER_NOTIFICATIONS_ENABLED]: false,
	[GENERAL_FORM_FIELDS.CONSUMER_NOTIFICATION_CHANNEL]: '',
	[GENERAL_FORM_FIELDS.MIT_CONSUMER_CURES_ENABLED]: false,
	[GENERAL_FORM_FIELDS.UI_WIDGET_OPTIONAL]: false,
	[GENERAL_FORM_FIELDS.CIT_CONSUMER_NOTIFICATIONS_ENABLED]: false,
	[GENERAL_FORM_FIELDS.ALLOW_BIN_CHECK]: false,
	[GENERAL_FORM_FIELDS.REFUND_ENABLED_CIT]: false,
	[GENERAL_FORM_FIELDS.REFUND_ENABLED_MIT]: false,
	[GENERAL_FORM_FIELDS.IS_SENSE_JS_OPTIONAL]: false,
	[GENERAL_FORM_FIELDS.USE_DEFAULT_SITE]: false,
	[GENERAL_FORM_FIELDS.ENABLE_ACCOUNT_UPDATE]: false,
	[GENERAL_FORM_FIELDS.ENABLE_GLOBAL_NETWORK_TOKENIZATION]: false,
	[GENERAL_FORM_FIELDS.ENABLE_CRAWLING]: false,
	[GENERAL_FORM_FIELDS.ENABLE_FRAME_EVENTS_COLLECT]: false,
	[GENERAL_FORM_FIELDS.ENABLE_ENFORCE_MFA]: false,
	[GENERAL_FORM_FIELDS.BILLING_INFORMATION_OPTIONAL]: false,
	[GENERAL_FORM_FIELDS.ENABLE_GLOBAL_3DS]: false,
	[GENERAL_FORM_FIELDS.INFORMATIONAL_3DS]: false,
	[GENERAL_FORM_FIELDS.CAPTURE_REQUIRED]: false,
	[GENERAL_FORM_FIELDS.ENABLE_MERCHANT_SCHEME_TRANSACTION_ID]: false,
	[GENERAL_FORM_FIELDS.REDACT_IP_ENABLED]: false,
	[GENERAL_FORM_FIELDS.PAYER_ENABLED]: false,
	[GENERAL_FORM_FIELDS.ENABLE_IMMEDIATE_RETRY]: false,
	[GENERAL_FORM_FIELDS.IS_AVS_REQUIRED]: false,
	[GENERAL_FORM_FIELDS.IS_CVV_REQUIRED]: false,
	[GENERAL_FORM_FIELDS.SUPPORTED_COUNTRIES]: [],
};

// Add initial values for admin funding configuration
export const initialAdminFundingConfigValues: FundingConfigFieldsTypes = {
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE]: false,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY]: null,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING]: null,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE]: null,
};

export const getPartnerFormattedGeneralFormFields = (formikValues): GeneralFieldsReturnTypes => ({
	locked: formikValues?.[GENERAL_FORM_FIELDS.LOCK_MERCHANT],
	// Add funding configuration
	fundingConfiguration: {
		payoutsEnabled: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE] || false,
		payoutFrequency: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY],
		payoutBatchesAutoPostingEnabled: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING],
		payoutBatchesSettledOffline: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE],
	}
});

// Add new function for formatting funding configuration fields
export const getPartnerFormattedFundingConfigFields = (formikValues): FundingConfigFieldsReturnTypes => ({
	payoutsEnabled: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE],
	payoutFrequency: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY],
	payoutBatchesAutoPostingEnabled: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING],
	payoutBatchesSettledOffline: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE],
});

export const getAdminFormattedGeneralFormFields = (formikValues): GeneralFieldsReturnTypes => ({
	// isBureauProductionActive: formikValues?.[GENERAL_FORM_FIELDS.BUREAU_PRODUCTION],
	locked: formikValues?.[GENERAL_FORM_FIELDS.LOCK_MERCHANT],
	// payoutsEnabled: formikValues?.[GENERAL_FORM_FIELDS.PAYOUTS_ENABLE],
	isMitEnabled: formikValues?.[GENERAL_FORM_FIELDS.MIT_ENABLE],
	isMITEvaluateAsync: formikValues?.[GENERAL_FORM_FIELDS.MIT_EVALUATE_ASYNC],
	isCITEvaluateAsync: formikValues?.[GENERAL_FORM_FIELDS.CIT_EVALUATE_ASYNC],
	virtualTerminalEnabled: formikValues?.[GENERAL_FORM_FIELDS.VIRTUAL_TERMINAL_ENABLED],
	mitGetSiteByDynamicDescriptorEnabled: formikValues?.[GENERAL_FORM_FIELDS.MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED],
	mitConsumerNotificationsEnabled: formikValues?.[GENERAL_FORM_FIELDS.MIT_CONSUMER_NOTIFICATIONS_ENABLED],
	consumerOrderNotificationChannel: formikValues?.[GENERAL_FORM_FIELDS.CONSUMER_NOTIFICATION_CHANNEL],
	mitConsumerCuresEnabled: formikValues?.[GENERAL_FORM_FIELDS.MIT_CONSUMER_CURES_ENABLED],
	uiWidgetOptional: formikValues?.[GENERAL_FORM_FIELDS.UI_WIDGET_OPTIONAL],
	citConsumerNotificationsEnabled: formikValues?.[GENERAL_FORM_FIELDS.CIT_CONSUMER_NOTIFICATIONS_ENABLED],
	allowBinCheckOnTokenization: formikValues?.[GENERAL_FORM_FIELDS.ALLOW_BIN_CHECK],
	citClickToRefundEnabled: formikValues?.[GENERAL_FORM_FIELDS.REFUND_ENABLED_CIT],
	mitClickToRefundEnabled: formikValues?.[GENERAL_FORM_FIELDS.REFUND_ENABLED_MIT],
	isSenseJsOptional: formikValues?.[GENERAL_FORM_FIELDS.IS_SENSE_JS_OPTIONAL],
	useDefaultSiteForUnknownMerchantUrlsEnabled: formikValues?.[GENERAL_FORM_FIELDS.USE_DEFAULT_SITE],
	accountUpdaterEnabled: formikValues?.[GENERAL_FORM_FIELDS.ENABLE_ACCOUNT_UPDATE],
	enableGlobalNetworkTokenization: formikValues?.[GENERAL_FORM_FIELDS.ENABLE_GLOBAL_NETWORK_TOKENIZATION],
	isCrawlingEnabled: formikValues?.[GENERAL_FORM_FIELDS.ENABLE_CRAWLING],
	isIframeMessagesCollectEnabled: formikValues?.[GENERAL_FORM_FIELDS.ENABLE_FRAME_EVENTS_COLLECT],
	isEnforceMFAEnabled: formikValues?.[GENERAL_FORM_FIELDS.ENABLE_ENFORCE_MFA],
	billingInformationOptional: formikValues?.[GENERAL_FORM_FIELDS.BILLING_INFORMATION_OPTIONAL],
	global3DSEnabled: formikValues?.[GENERAL_FORM_FIELDS.ENABLE_GLOBAL_3DS],
	informationalOnly3DS: formikValues?.[GENERAL_FORM_FIELDS.INFORMATIONAL_3DS],
	captureRequired: formikValues?.[GENERAL_FORM_FIELDS.CAPTURE_REQUIRED],
	schemeTransactionIdEnabled: formikValues?.[GENERAL_FORM_FIELDS.ENABLE_MERCHANT_SCHEME_TRANSACTION_ID],
	redactIpEnabled: formikValues?.[GENERAL_FORM_FIELDS.REDACT_IP_ENABLED],
	payerEnabled: formikValues?.[GENERAL_FORM_FIELDS.PAYER_ENABLED],
	mitImmediateRetryEnabled: formikValues?.[GENERAL_FORM_FIELDS.ENABLE_IMMEDIATE_RETRY],
	isAvsRequired: formikValues?.[GENERAL_FORM_FIELDS.IS_AVS_REQUIRED],
	isCvvRequired: formikValues?.[GENERAL_FORM_FIELDS.IS_CVV_REQUIRED],
	supportedCountries: formikValues?.[GENERAL_FORM_FIELDS.SUPPORTED_COUNTRIES],
	// Add funding configuration
	fundingConfiguration: {
		payoutsEnabled: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE] || false,
		payoutFrequency: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY],
		payoutBatchesAutoPostingEnabled: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING],
		payoutBatchesSettledOffline: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE],
	}
});

// Add new function for formatting admin funding configuration fields
export const getAdminFormattedFundingConfigFields = (formikValues): FundingConfigFieldsReturnTypes => ({
	payoutsEnabled: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE],
	payoutFrequency: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY],
	payoutBatchesAutoPostingEnabled: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING],
	payoutBatchesSettledOffline: formikValues?.[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE],
});

export const convertPartnerToGeneralInitialValues = (data): GeneralFieldsTypes => ({
	[GENERAL_FORM_FIELDS.LOCK_MERCHANT]: data?.locked,
	// [GENERAL_FORM_FIELDS.PAYOUTS_ENABLE]: data?.payoutsEnabled,

	// Include funding configuration fields
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE]: data?.fundingConfiguration?.payoutsEnabled || false,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY]: data?.fundingConfiguration?.payoutFrequency || null,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING]: data?.fundingConfiguration?.payoutBatchesAutoPostingEnabled || null,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE]: data?.fundingConfiguration?.payoutBatchesSettledOffline || null,
});

export const convertAdminToGeneralInitialValues = (data): GeneralFieldsTypes => ({
	// [GENERAL_FORM_FIELDS.BUREAU_PRODUCTION]: data?.isBureauProductionActive,
	[GENERAL_FORM_FIELDS.LOCK_MERCHANT]: data?.locked,
	// [GENERAL_FORM_FIELDS.PAYOUTS_ENABLE]: data?.payoutsEnabled,
	[GENERAL_FORM_FIELDS.MIT_ENABLE]: data?.isMitEnabled,
	[GENERAL_FORM_FIELDS.MIT_EVALUATE_ASYNC]: data?.isMITEvaluateAsync,
	[GENERAL_FORM_FIELDS.CIT_EVALUATE_ASYNC]: data?.isCITEvaluateAsync,
	[GENERAL_FORM_FIELDS.VIRTUAL_TERMINAL_ENABLED]: data?.virtualTerminalEnabled,
	[GENERAL_FORM_FIELDS.MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED]: data?.mitGetSiteByDynamicDescriptorEnabled,
	[GENERAL_FORM_FIELDS.MIT_CONSUMER_NOTIFICATIONS_ENABLED]: data?.mitConsumerNotificationsEnabled,
	[GENERAL_FORM_FIELDS.CONSUMER_NOTIFICATION_CHANNEL]: data?.consumerOrderNotificationChannel,
	[GENERAL_FORM_FIELDS.MIT_CONSUMER_CURES_ENABLED]: data?.mitConsumerCuresEnabled,
	[GENERAL_FORM_FIELDS.UI_WIDGET_OPTIONAL]: data?.uiWidgetOptional,
	[GENERAL_FORM_FIELDS.CIT_CONSUMER_NOTIFICATIONS_ENABLED]: data?.citConsumerNotificationsEnabled,
	[GENERAL_FORM_FIELDS.ALLOW_BIN_CHECK]: data?.allowBinCheckOnTokenization,
	[GENERAL_FORM_FIELDS.REFUND_ENABLED_CIT]: data?.citClickToRefundEnabled,
	[GENERAL_FORM_FIELDS.REFUND_ENABLED_MIT]: data?.mitClickToRefundEnabled,
	[GENERAL_FORM_FIELDS.IS_SENSE_JS_OPTIONAL]: data?.isSenseJsOptional,
	[GENERAL_FORM_FIELDS.USE_DEFAULT_SITE]: data?.useDefaultSiteForUnknownMerchantUrlsEnabled,
	[GENERAL_FORM_FIELDS.ENABLE_ACCOUNT_UPDATE]: data?.accountUpdaterEnabled,
	[GENERAL_FORM_FIELDS.ENABLE_GLOBAL_NETWORK_TOKENIZATION]: data?.enableGlobalNetworkTokenization,
	[GENERAL_FORM_FIELDS.ENABLE_CRAWLING]: data?.isCrawlingEnabled,
	[GENERAL_FORM_FIELDS.ENABLE_FRAME_EVENTS_COLLECT]: data?.isIframeMessagesCollectEnabled,
	[GENERAL_FORM_FIELDS.ENABLE_ENFORCE_MFA]: data?.isEnforceMFAEnabled,
	[GENERAL_FORM_FIELDS.BILLING_INFORMATION_OPTIONAL]: data?.billingInformationOptional,
	[GENERAL_FORM_FIELDS.ENABLE_GLOBAL_3DS]: data?.global3DSEnabled,
	[GENERAL_FORM_FIELDS.INFORMATIONAL_3DS]: data?.informationalOnly3DS,
	[GENERAL_FORM_FIELDS.CAPTURE_REQUIRED]: data?.captureRequired,
	[GENERAL_FORM_FIELDS.ENABLE_MERCHANT_SCHEME_TRANSACTION_ID]: data?.schemeTransactionIdEnabled,
	[GENERAL_FORM_FIELDS.REDACT_IP_ENABLED]: data?.redactIpEnabled,
	[GENERAL_FORM_FIELDS.PAYER_ENABLED]: data?.payerEnabled,
	[GENERAL_FORM_FIELDS.ENABLE_IMMEDIATE_RETRY]: data?.mitImmediateRetryEnabled,
	[GENERAL_FORM_FIELDS.IS_AVS_REQUIRED]: data?.isAvsRequired,
	[GENERAL_FORM_FIELDS.IS_CVV_REQUIRED]: data?.isCvvRequired,
	[GENERAL_FORM_FIELDS.SUPPORTED_COUNTRIES]: data?.supportedCountries,

	// Include funding configuration fields
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE]: data?.fundingConfiguration?.payoutsEnabled || false,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY]: data?.fundingConfiguration?.payoutFrequency || null,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING]: data?.fundingConfiguration?.payoutBatchesAutoPostingEnabled || null,
	[FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE]: data?.fundingConfiguration?.payoutBatchesSettledOffline || null,
});

export const getPartnerFormattedGeneralData = (data): GeneralFieldsReturnTypes => ({
	// isBureauProductionActive: data?.isBureauProductionActive,
	locked: data?.locked,
	// payoutsEnabled: data?.payoutsEnabled,
});

// Add new function for formatting partner funding configuration data
export const getPartnerFormattedFundingConfigData = (data): FundingConfigFieldsReturnTypes => ({
	payoutsEnabled: data?.fundingConfiguration?.payoutsEnabled || false,
	payoutFrequency: data?.fundingConfiguration?.payoutFrequency || null,
	payoutBatchesAutoPostingEnabled: data?.fundingConfiguration?.payoutBatchesAutoPostingEnabled || null,
	payoutBatchesSettledOffline: data?.fundingConfiguration?.payoutBatchesSettledOffline || null,
});

export const getAdminFormattedGeneralData = (data): GeneralFieldsReturnTypes => ({
	// isBureauProductionActive: data?.isBureauProductionActive,
	locked: data?.locked,
	// payoutsEnabled: data?.payoutsEnabled,
	isMitEnabled: data?.isMitEnabled,
	isMITEvaluateAsync: data?.isMITEvaluateAsync,
	isCITEvaluateAsync: data?.isCITEvaluateAsync,
	virtualTerminalEnabled: data?.virtualTerminalEnabled,
	mitGetSiteByDynamicDescriptorEnabled: data?.mitGetSiteByDynamicDescriptorEnabled,
	mitConsumerNotificationsEnabled: data?.mitConsumerNotificationsEnabled,
	mitConsumerCuresEnabled: data?.mitConsumerCuresEnabled,
	uiWidgetOptional: data?.uiWidgetOptional,
	citConsumerNotificationsEnabled: data?.citConsumerNotificationsEnabled,
	allowBinCheckOnTokenization: data?.allowBinCheckOnTokenization,
	citClickToRefundEnabled: data?.citClickToRefundEnabled,
	mitClickToRefundEnabled: data?.mitClickToRefundEnabled,
	isSenseJsOptional: data?.isSenseJsOptional,
	useDefaultSiteForUnknownMerchantUrlsEnabled: data?.useDefaultSiteForUnknownMerchantUrlsEnabled,
	accountUpdaterEnabled: data?.accountUpdaterEnabled,
	enableGlobalNetworkTokenization: data?.enableGlobalNetworkTokenization,
	isCrawlingEnabled: data?.isCrawlingEnabled,
	isIframeMessagesCollectEnabled: data?.isIframeMessagesCollectEnabled,
	isEnforceMFAEnabled: data?.isEnforceMFAEnabled,
	billingInformationOptional: data?.billingInformationOptional,
	consumerOrderNotificationChannel: data?.consumerOrderNotificationChannel ? data?.consumerOrderNotificationChannel : '',
	global3DSEnabled: data?.global3DSEnabled,
	informationalOnly3DS: data?.informationalOnly3DS,
	captureRequired: data?.captureRequired,
	schemeTransactionIdEnabled: data?.schemeTransactionIdEnabled,
	mitImmediateRetryEnabled: data?.mitImmediateRetryEnabled,
	isAvsRequired: data?.isAvsRequired,
	isCvvRequired: data?.isCvvRequired,
	supportedCountries: data?.supportedCountries,
});

// Add new function for formatting admin funding configuration data
export const getAdminFormattedFundingConfigData = (data): FundingConfigFieldsReturnTypes => ({
	payoutsEnabled: data?.fundingConfiguration?.payoutsEnabled || false,
	payoutFrequency: data?.fundingConfiguration?.payoutFrequency || null,
	payoutBatchesAutoPostingEnabled: data?.fundingConfiguration?.payoutBatchesAutoPostingEnabled || null,
	payoutBatchesSettledOffline: data?.fundingConfiguration?.payoutBatchesSettledOffline || null,
});

export interface ISwitchersProps {
	title: GENERAL_FORM_FIELDS_NAMES | FUNDING_CONFIG_FORM_FIELDS_NAMES;
	formName: GENERAL_FORM_FIELDS | FUNDING_CONFIG_FORM_FIELDS;
	description: GENERAL_FORM_FIELDS_NAMES | FUNDING_CONFIG_FORM_FIELDS_NAMES;
}

export const adminSwitchesNames = [
	// {
	// 	title: GENERAL_FORM_FIELDS_NAMES.BUREAU_PRODUCTION,
	// 	formName: GENERAL_FORM_FIELDS.BUREAU_PRODUCTION
	// },
	{
		category: 'GENERAL_SECTION.ACCOUNT_SETTINGS',
		items: [
			{
				title: GENERAL_FORM_FIELDS_NAMES.LOCK_MERCHANT,
				formName: GENERAL_FORM_FIELDS.LOCK_MERCHANT,
				description: GENERAL_FORM_FIELDS_NAMES.LOCK_MERCHANT_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.ENABLE_ACCOUNT_UPDATE,
				formName: GENERAL_FORM_FIELDS.ENABLE_ACCOUNT_UPDATE,
				description: GENERAL_FORM_FIELDS_NAMES.ENABLE_ACCOUNT_UPDATE_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.ENABLE_GLOBAL_NETWORK_TOKENIZATION,
				formName: GENERAL_FORM_FIELDS.ENABLE_GLOBAL_NETWORK_TOKENIZATION,
				description: GENERAL_FORM_FIELDS_NAMES.ENABLE_GLOBAL_NETWORK_TOKENIZATION_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.ENABLE_CRAWLING,
				formName: GENERAL_FORM_FIELDS.ENABLE_CRAWLING,
				description: GENERAL_FORM_FIELDS_NAMES.ENABLE_CRAWLING_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.ENABLE_FRAME_EVENTS_COLLECT,
				formName: GENERAL_FORM_FIELDS.ENABLE_FRAME_EVENTS_COLLECT,
				description: GENERAL_FORM_FIELDS_NAMES.ENABLE_FRAME_EVENTS_COLLECT_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.ENABLE_ENFORCE_MFA,
				formName: GENERAL_FORM_FIELDS.ENABLE_ENFORCE_MFA,
				description: GENERAL_FORM_FIELDS_NAMES.ENABLE_ENFORCE_MFA_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.ENABLE_GLOBAL_3DS,
				formName: GENERAL_FORM_FIELDS.ENABLE_GLOBAL_3DS,
				description: GENERAL_FORM_FIELDS_NAMES.ENABLE_GLOBAL_3DS_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.INFORMATIONAL_3DS,
				formName: GENERAL_FORM_FIELDS.INFORMATIONAL_3DS,
				description: GENERAL_FORM_FIELDS_NAMES.INFORMATIONAL_3DS_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.CAPTURE_REQUIRED,
				formName: GENERAL_FORM_FIELDS.CAPTURE_REQUIRED,
				description: GENERAL_FORM_FIELDS_NAMES.CAPTURE_REQUIRED_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.ENABLE_MERCHANT_SCHEME_TRANSACTION_ID,
				formName: GENERAL_FORM_FIELDS.ENABLE_MERCHANT_SCHEME_TRANSACTION_ID,
				description: GENERAL_FORM_FIELDS_NAMES.ENABLE_MERCHANT_SCHEME_TRANSACTION_ID_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.PAYER_ENABLED,
				formName: GENERAL_FORM_FIELDS.PAYER_ENABLED,
				description: GENERAL_FORM_FIELDS_NAMES.PAYER_ENABLED_DESCRIPTION
			}
			// {
			// 	title: GENERAL_FORM_FIELDS_NAMES.IS_AVS_REQUIRED,
			// 	formName: GENERAL_FORM_FIELDS.IS_AVS_REQUIRED,
			// 	description: GENERAL_FORM_FIELDS_NAMES.IS_AVS_REQUIRED_DESCRIPTION
			// },
			// {
			// 	title: GENERAL_FORM_FIELDS_NAMES.IS_CVV_REQUIRED,
			// 	formName: GENERAL_FORM_FIELDS.IS_CVV_REQUIRED,
			// 	description: GENERAL_FORM_FIELDS_NAMES.IS_CVV_REQUIRED_DESCRIPTION
			// },
		]
	},
	{
		category: 'GENERAL_SECTION.TRANSACTION_PROCESSING_SETTINGS',
		items: [
			{
				title: GENERAL_FORM_FIELDS_NAMES.MIT_EVALUATE_ASYNC,
				formName: GENERAL_FORM_FIELDS.MIT_EVALUATE_ASYNC,
				description: GENERAL_FORM_FIELDS_NAMES.MIT_EVALUATE_ASYNC_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.CIT_EVALUATE_ASYNC,
				formName: GENERAL_FORM_FIELDS.CIT_EVALUATE_ASYNC,
				description: GENERAL_FORM_FIELDS_NAMES.CIT_EVALUATE_ASYNC_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.VIRTUAL_TERMINAL_ENABLED,
				formName: GENERAL_FORM_FIELDS.VIRTUAL_TERMINAL_ENABLED,
				description: GENERAL_FORM_FIELDS_NAMES.VIRTUAL_TERMINAL_ENABLED_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.ALLOW_BIN_CHECK,
				formName: GENERAL_FORM_FIELDS.ALLOW_BIN_CHECK,
				description: GENERAL_FORM_FIELDS_NAMES.ALLOW_BIN_CHECK_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.USE_DEFAULT_SITE,
				formName: GENERAL_FORM_FIELDS.USE_DEFAULT_SITE,
				description: GENERAL_FORM_FIELDS_NAMES.USE_DEFAULT_SITE_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.BILLING_INFORMATION_OPTIONAL,
				formName: GENERAL_FORM_FIELDS.BILLING_INFORMATION_OPTIONAL,
				description: GENERAL_FORM_FIELDS_NAMES.BILLING_INFORMATION_OPTIONAL_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.REDACT_IP_ENABLED,
				formName: GENERAL_FORM_FIELDS.REDACT_IP_ENABLED,
				description: GENERAL_FORM_FIELDS_NAMES.REDACT_IP_ENABLED_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.SUPPORTED_COUNTRIES,
				formName: GENERAL_FORM_FIELDS.SUPPORTED_COUNTRIES,
				description: GENERAL_FORM_FIELDS_NAMES.SUPPORTED_COUNTRIES_DESCRIPTION
			},
		]
	},
	{
		category: 'GENERAL_SECTION.TRANSACTION_SETTINGS',
		items: [
			{
				title: GENERAL_FORM_FIELDS_NAMES.MIT_ENABLE,
				formName: GENERAL_FORM_FIELDS.MIT_ENABLE,
				description: GENERAL_FORM_FIELDS_NAMES.MIT_ENABLE_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED,
				formName: GENERAL_FORM_FIELDS.MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED,
				description: GENERAL_FORM_FIELDS_NAMES.MIT_GET_SITE_BY_DYNAMIC_DESCRIPTION_ENABLED_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.ENABLE_IMMEDIATE_RETRY,
				formName: GENERAL_FORM_FIELDS.ENABLE_IMMEDIATE_RETRY,
				description: GENERAL_FORM_FIELDS_NAMES.ENABLE_IMMEDIATE_RETRY_DESCRIPTION
			},
		]
	},
	{
		category: 'GENERAL_SECTION.FUNDING_CONFIGURATION',
		items: [
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUTS_ENABLE,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUTS_ENABLE_DESCRIPTION
			},
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_AUTO_POSTING,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_AUTO_POSTING_DESCRIPTION
			},
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_SETTLED_OFFLINE,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_SETTLED_OFFLINE_DESCRIPTION
			},
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_FREQUENCY,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUT_FREQUENCY,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_FREQUENCY_DESCRIPTION
			},
		],
	},
	{
		category: 'GENERAL_SECTION.OPTIONAL_INTEGRATION',
		items: [
			{
				title: GENERAL_FORM_FIELDS_NAMES.IS_SENSE_JS_OPTIONAL,
				formName: GENERAL_FORM_FIELDS.IS_SENSE_JS_OPTIONAL,
				description: GENERAL_FORM_FIELDS_NAMES.IS_SENSE_JS_OPTIONAL_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.UI_WIDGET_OPTIONAL,
				formName: GENERAL_FORM_FIELDS.UI_WIDGET_OPTIONAL,
				description: GENERAL_FORM_FIELDS_NAMES.UI_WIDGET_OPTIONAL_DESCRIPTION
			},
		]
	},
	{
		category: 'GENERAL_SECTION.CUSTOMER_NOTIFICATIONS',
		items: [
			{
				title: GENERAL_FORM_FIELDS_NAMES.CIT_CONSUMER_NOTIFICATIONS_ENABLED,
				formName: GENERAL_FORM_FIELDS.CIT_CONSUMER_NOTIFICATIONS_ENABLED,
				description: GENERAL_FORM_FIELDS_NAMES.CIT_CONSUMER_NOTIFICATIONS_ENABLED_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.MIT_CONSUMER_NOTIFICATIONS_ENABLED,
				formName: GENERAL_FORM_FIELDS.MIT_CONSUMER_NOTIFICATIONS_ENABLED,
				description: GENERAL_FORM_FIELDS_NAMES.MIT_CONSUMER_NOTIFICATIONS_ENABLED_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.MIT_CONSUMER_CURES_ENABLED,
				formName: GENERAL_FORM_FIELDS.MIT_CONSUMER_CURES_ENABLED,
				description: GENERAL_FORM_FIELDS_NAMES.MIT_CONSUMER_CURES_ENABLED_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.CONSUMER_NOTIFICATION_CHANNEL,
				formName: GENERAL_FORM_FIELDS.CONSUMER_NOTIFICATION_CHANNEL,
				description: GENERAL_FORM_FIELDS_NAMES.CONSUMER_NOTIFICATION_CHANNEL_DESCRIPTION
			},
		]
	},
	{
		category: 'GENERAL_SECTION.REFUND_SETTINGS',
		items: [
			{
				title: GENERAL_FORM_FIELDS_NAMES.REFUND_ENABLED_CIT,
				formName: GENERAL_FORM_FIELDS.REFUND_ENABLED_CIT,
				description: GENERAL_FORM_FIELDS_NAMES.REFUND_ENABLED_CIT_DESCRIPTION
			},
			{
				title: GENERAL_FORM_FIELDS_NAMES.REFUND_ENABLED_MIT,
				formName: GENERAL_FORM_FIELDS.REFUND_ENABLED_MIT,
				description: GENERAL_FORM_FIELDS_NAMES.REFUND_ENABLED_MIT_DESCRIPTION
			},
		]
	},
];

// Add new funding configuration switches
export const adminFundingConfigSwitchesNames = [
	{
		category: 'GENERAL_SECTION.FUNDING_CONFIGURATION',
		items: [
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUTS_ENABLE,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUTS_ENABLE_DESCRIPTION
			},
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_AUTO_POSTING,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_AUTO_POSTING_DESCRIPTION
			},
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_SETTLED_OFFLINE,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_SETTLED_OFFLINE_DESCRIPTION
			},
		],
	}
];

export const partnerSwitchesNames = [
	{
		category: 'GENERAL_SECTION.ACCOUNT_SETTINGS',
		items: [
			{
				title: GENERAL_FORM_FIELDS_NAMES.LOCK_MERCHANT,
				formName: GENERAL_FORM_FIELDS.LOCK_MERCHANT,
				description: GENERAL_FORM_FIELDS_NAMES.LOCK_MERCHANT_DESCRIPTION
			},
		],
	}
];

// Add partner funding configuration switches
export const partnerFundingConfigSwitchesNames = [
	{
		category: 'GENERAL_SECTION.FUNDING_CONFIGURATION',
		items: [
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUTS_ENABLE,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUTS_ENABLE,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUTS_ENABLE_DESCRIPTION
			},
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_AUTO_POSTING,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_AUTO_POSTING,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_AUTO_POSTING_DESCRIPTION
			},
			{
				title: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_SETTLED_OFFLINE,
				formName: FUNDING_CONFIG_FORM_FIELDS.PAYOUT_BATCHES_SETTLED_OFFLINE,
				description: FUNDING_CONFIG_FORM_FIELDS_NAMES.PAYOUT_BATCHES_SETTLED_OFFLINE_DESCRIPTION
			},
		],
	}
];
